import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({
  /* pass a configuration object here if needed */
});

export default browserHistory;
